export var ASSIGNEE_FIELD = 'assignee';
export var CREATED_FIELD = 'created';
export var DUE_DATE_FIELD = 'duedate';
export var ISSUE_KEY_FIELD = 'issuekey';
export var ISSUE_TYPE_FIELD = 'issuetype';
export var LAST_VIEWED_FIELD = 'lastviewed';
export var PRIORITY_FIELD = 'priority';
export var PROJECT_FIELD = 'project';
export var REPORTER_FIELD = 'reporter';
export var RESOLVED_FIELD = 'resolved';
export var RESOLUTION_DATE_FIELD = 'resolutiondate';
export var STATUS_FIELD = 'status';
export var STATUS_CATEGORY_FIELD = 'statuscategory';
export var SUMMARY_FIELD = 'summary';
export var TEXT_FIELD = 'text';
export var TEXFIELDS_FIELD = 'textfields';
export var TYPE_FIELD = 'type';
export var UPDATED_FIELD = 'updated';
export var AFFECTED_VERSION_FIELD = 'affectedversion';
export var APPROVALS_FIELD = 'approvals';
export var CATEGORY_FIELD = 'category';
export var COMPONENT_FIELD = 'component';
export var DESCRIPTION_FIELD = 'description';
export var DEVELOPMENT_FIELD = 'development';
export var ENVIRONMENT_FIELD = 'environment';
export var EPIC_LINK_FIELD = 'epic link';
export var FILTER_FIELD = 'filter';
export var FIX_VERSION_FIELD = 'fixversion';
export var LABELS_FIELD = 'labels';
export var PARENT_FIELD = 'parent';
export var RESOLUTION_FIELD = 'resolution';
export var SPRINT_FIELD = 'sprint';
export var ASSIGNEE_PROPERTY = 'assignee.property';
export var CREATOR_PROPERTY = 'creator.property';
export var ISSUE_PROPERTY = 'issue.property';
export var PROJECT_PROPERTY = 'project.property';
export var REPORTER_PROPERTY = 'reporter.property';
export var VOTER_PROPERTY = 'voter.property';
export var WATCHER_PROPERTY = 'watcher.property';

// List of Jira system fields that don't need to be anonymized. This list may not be exhaustive and is only used to
// provide extra insight when analysing JQL.
// All the field names here must be in lowercase
export var PRIVACY_SAFE_FIELDS = [ASSIGNEE_FIELD, CREATED_FIELD, DUE_DATE_FIELD, ISSUE_KEY_FIELD, ISSUE_TYPE_FIELD, LAST_VIEWED_FIELD, PRIORITY_FIELD, PROJECT_FIELD, REPORTER_FIELD, RESOLVED_FIELD, RESOLUTION_DATE_FIELD, STATUS_FIELD, STATUS_CATEGORY_FIELD, SUMMARY_FIELD, TEXT_FIELD, TEXFIELDS_FIELD, TYPE_FIELD, UPDATED_FIELD, AFFECTED_VERSION_FIELD, APPROVALS_FIELD, CATEGORY_FIELD, COMPONENT_FIELD, DESCRIPTION_FIELD, DEVELOPMENT_FIELD, ENVIRONMENT_FIELD, EPIC_LINK_FIELD, FILTER_FIELD, FIX_VERSION_FIELD, LABELS_FIELD, PARENT_FIELD, RESOLUTION_FIELD, SPRINT_FIELD,
// entity properties
ASSIGNEE_PROPERTY, CREATOR_PROPERTY, ISSUE_PROPERTY, PROJECT_PROPERTY, REPORTER_PROPERTY, VOTER_PROPERTY, WATCHER_PROPERTY];